import React from 'react'
import Dropdown from 'components/ui/Selector'
import { useForm } from '.'

const OrderBys = [
  { code: 'updateTime', name: 'updateTime' },
  { code: 'dailyCount.downloadCount', name: 'dailyCount.downloadCount' },
  { code: 'weeklyCount.downloadCount', name: 'weeklyCount.downloadCount' },
  { code: 'monthlyCount.downloadCount', name: 'monthlyCount.downloadCount' },
]

const CustomDropdown = () => {
  const value = useForm((state) => state.order)
  const update = useForm((state) => state.setOrder)
  return (
    <Dropdown
      id="webimgs-order"
      datas={OrderBys}
      showLabel
      labelName="Order"
      value={value}
      update={update}
    />
  )
}

export default CustomDropdown
